// extracted by mini-css-extract-plugin
module.exports = {"draftLeft":"alignmentStyles_draftLeft__E7oG-","draftRight":"alignmentStyles_draftRight__3-Xz_","draftCenter":"alignmentStyles_draftCenter__HpW7t"};